import { render, staticRenderFns } from "./Gebäude.vue?vue&type=template&id=7f238fb2&"
import script from "./Gebäude.vue?vue&type=script&lang=js&"
export * from "./Gebäude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports